import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { queryClient } from '../../../App'
import { isAdmin, isDealer } from '../../../services/AccountService'
import { getRequestsTable } from '../../../services/NewApiService'
import { getComp } from '../../../utils/utils/DI'
import { singleReportPaginationStore } from '../components/SingleReportTableFilters'
import { REPORT_KEYS } from '../consts/request-report.keys'

export const useSingleReportTableData = (reportId: number) => {
  const mountedRef = useRef(false) // что-бы setSelectedRow не срабатывал на mount
  const {
    page,
    size,
    sort,
    params: {
      statuses,
      dataCheckingStatus,
      dealerIds,
      district,
      equipmentId,
      isExpired,
      reason,
      reasonId,
      territory,
      to,
      installedTo,
      installedFrom,
      isSuspicious,
      authorId,
      SenderGroupIds,
      financialSourceIds,
      phone,
      preferentialCategory,
      priorities,
      namePartial,
      surnamePartial,
      address,
      agreementCheckingStatus,
      senderId,
      source,
      hasDuplicates,
      from,
      fullName,
      locality,
      categories,
      orderId,
    },
    setSelectedRow,
  } = singleReportPaginationStore

  useEffect(() => {
    if (mountedRef.current) {
      setSelectedRow(null, 0)
    } else {
      mountedRef.current = true
    }
  }, [
    statuses,
    dataCheckingStatus,
    dealerIds,
    district,
    equipmentId,
    isExpired,
    reason,
    reasonId,
    reportId,
    territory,
    to,
    installedTo,
    installedFrom,
    isSuspicious,
    authorId,
    SenderGroupIds,
    financialSourceIds,
    phone,
    preferentialCategory,
    priorities,
    namePartial,
    surnamePartial,
    address,
    agreementCheckingStatus,
    senderId,
    source,
    hasDuplicates,
    from,
    fullName,
    locality,
    categories,
    orderId,
    categories,
  ])

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        REPORT_KEYS.GET_REPORT_TABLE,
        size,
        page,
        sort,
        statuses,
        dataCheckingStatus,
        dealerIds,
        district,
        equipmentId,
        isExpired,
        reason,
        reasonId,
        reportId,
        territory,
        to,
        installedTo,
        installedFrom,
        isSuspicious,
        authorId,
        SenderGroupIds,
        financialSourceIds,
        phone,
        preferentialCategory,
        priorities,
        namePartial,
        surnamePartial,
        address,
        agreementCheckingStatus,
        senderId,
        source,
        hasDuplicates,
        from,
        fullName,
        locality,
        categories,
        orderId,
      ],
      queryFn: () =>
        getRequestsTable({
          size,
          page,
          sort,
          statuses,
          dataCheckingStatus,
          dealerIds,
          district,
          equipmentId,
          isExpired,
          reason,
          reasonId,
          reportId: String(reportId),
          territory,
          to,
          installedTo,
          installedFrom,
          isSuspicious,
          authorId,
          SenderGroupIds,
          financialSourceIds,
          phone,
          preferentialCategory,
          priorities,
          namePartial,
          surnamePartial,
          address,
          agreementCheckingStatus,
          senderId,
          source,
          hasDuplicates,
          from,
          fullName,
          locality,
          categories,
          orderId,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId && (!!isAdmin() || !!isDealer()),
    },
    queryClient,
  )
}
